module.exports = __webpack_public_path__ + "static/media/Milhouse Van Houten.d5ff6edd.png";